import {RuntimeMode} from "../js/utils/Types.ts";

//region API URL
export const ROOMJACK_API_URL = process.env.REACT_APP_ROOMJACK_API_URL || "not-configured";
//endregion
//region Stripe public key
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || "not-configured";
//endregion
export const RUNTIME_MODE = process.env.REACT_APP_RUNTIME_MODE || RuntimeMode.development;
